import { GamePlayConfig, QueryResponse } from 'shared-services'
import { SettlingGame, settlingGameNull } from '../models/settling-game'
import { settlingGameMapper } from '../mappers/settling-game.mapper'
import { GetGameErrorCode } from '../error-codes/get-game.error-code'
import { GamePlayGameId } from '../models/game-play-game-id'
import { GameDto } from '../dtos/game.dto'

export class SettlingService {
  public constructor(private readonly gamePlayConfig: GamePlayConfig) {}

  public async getSettlingGame(
    gamePlayGameId: GamePlayGameId,
  ): Promise<QueryResponse<SettlingGame, GetGameErrorCode>> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId
    const query = `gamePlayId=${gamePlayId}&gameId=${gameId}`

    const response = await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/settling/v1/settling-game?${query}`,
      {
        credentials: 'include',
      },
    )

    const settlingGameResponse = (await response.json()) as QueryResponse<
      GameDto,
      GetGameErrorCode
    >

    const result = settlingGameResponse.isSuccessful
      ? settlingGameMapper.mapToSettlingGame(settlingGameResponse.result)
      : settlingGameNull

    return {
      errorCode: settlingGameResponse.errorCode,
      errorCodes: settlingGameResponse.errorCodes,
      isSuccessful: settlingGameResponse.isSuccessful,
      result,
    }
  }

  public async confirmResults(gamePlayGameId: GamePlayGameId): Promise<void> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId

    const body = {
      gamePlayId,
      gameId,
    }

    await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/settling/v1/confirm-results`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  }
}
